import React from 'react';
import acc from "accounting";
import ButtonComponent from "../Button";
import './styles.less';

const statData = [
    {
        key: 'price',
        title: 'Price',
    },
    {
        key: 'reviews',
        title: 'Reviews',
    },
    {
        key: 'version',
        title: 'Version',
    },
    {
        key: 'release_date',
        title: 'Release date',
    },
];

const Index = ({skeleton, isMobile, result}) => {

    if (skeleton) return (
        <div className={'theme-info-wrapper'}>
            <span className={'link-skeleton'} style={{width: 250, height: 24}}/>
            <div className={'theme-info'}>
                <div className="image">
                    <span className={'link-skeleton'} style={{width: '100%', height: isMobile ? 'unset' : '100%', aspectRatio: isMobile ? '16/9' : 'unset', borderRadius: 16}}/>
                </div>
                <div className="data">
                    <span className="comment">
                        <span className={'link-skeleton'} style={{width: 160, height: 18}}/>
                    </span>
                    <h3 className="title">
                        <span className={'link-skeleton'} style={{width: 49, height: 28}}/>
                    </h3>
                    <div className="stat-wrapper">
                        {
                            [1,2,3,4].map((item) => (
                                <div className="stat"
                                     key={item}
                                >
                                    <span className="title">
                                        <span className={'link-skeleton'} style={{width: 54, height: 20}}/>
                                    </span>
                                    <span className="value">
                                        <span className={'link-skeleton'} style={{width: 84, height: 20}}/>
                                    </span>
                                </div>
                            ))
                        }
                    </div>
                    <span className={'link-skeleton'} style={{width: isMobile ? '100%' : 125, height: 36, marginTop: 24}}/>
                </div>
            </div>
        </div>
    )

    return (
        <div className={'theme-info-wrapper'}>
            <h3>
                Theme information
            </h3>
            <div className={'theme-info'}>
                <div className="image">
                    <img src={result?.storeImage}
                         onError={e => {
                             e.target.src = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12.6667 4.66675C10.0893 4.66675 8 6.75609 8 9.33342C8 11.9107 10.0893 14.0001 12.6667 14.0001C15.244 14.0001 17.3333 11.9107 17.3333 9.33342C17.3333 6.75609 15.244 4.66675 12.6667 4.66675Z" fill="#225AEA"/><path d="M28.4964 19.9243C27.5549 17.4568 26.5763 15.4997 25.5596 14.1606C24.5753 12.8641 23.3564 11.8946 21.9168 12.0139C19.4325 12.2197 17.7574 14.2506 16.5742 15.8011C16.4106 16.0155 16.2563 16.2214 16.1088 16.4181C15.6747 16.9971 15.2999 17.4969 14.9246 17.9004C14.3986 18.4657 14.118 18.5584 13.9993 18.5584C13.75 18.5584 13.4472 18.4727 13.0432 18.264C12.6788 18.0759 12.3082 17.8302 11.87 17.5397L11.6977 17.4256C10.7443 16.7953 9.46082 15.9612 7.91686 15.9612C6.78022 15.9612 5.87277 16.6407 5.20608 17.3972C4.52616 18.1687 3.95783 19.1733 3.49657 20.1659L3.40983 20.3521C2.86212 21.5266 2.41724 22.4806 2.60704 23.6083C2.68802 24.0896 2.89669 24.5622 3.15047 24.96C3.40426 25.3578 3.74497 25.7462 4.14723 26.0225C4.67216 26.3829 5.24167 26.5329 5.86118 26.6018C6.44311 26.6666 7.15175 26.6665 7.98824 26.6665H23.7134C24.6305 26.6665 25.3907 26.6665 26.0023 26.6072C26.6371 26.5456 27.2289 26.4119 27.7566 26.0657C28.5319 25.5571 29.128 24.6916 29.3268 23.786C29.46 23.179 29.3855 22.5991 29.2257 22.0034C29.0738 21.4375 28.8187 20.7689 28.5145 19.9717L28.4964 19.9243Z" fill="#225AEA"/></svg>';
                         }}
                         alt="theme-icon"
                    />
                </div>
                <div className="data">
                    <span className="comment">
                        <a href={result?.metaData?.url} rel="noopener noreferrer" target="_blank">{result?.metaData?.domain}</a> is built using...
                    </span>
                    <h3 className="title">
                        {result?.themeInfo?.theme_assignment?.schema_name || 'No data'}
                    </h3>
                    <div className="stat-wrapper">
                        {
                            statData.map((item) => (
                                <div className="stat"
                                     key={item.key}
                                >
                                <span className="title">
                                    {item.title}
                                </span>
                                    {
                                        item?.key === 'reviews' ?
                                            <span className="value">
                                                {acc.formatNumber(result?.themeInfo?.theme_store_meta?.rating * 5 / 100, 1, ',', '.')}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                     viewBox="0 0 16 16" fill="none"><path
                                                    d="M8.91502 1.24156C8.54684 0.475144 7.45313 0.475141 7.08495 1.24156L5.51021 4.5196L1.88306 4.99452C1.04215 5.10463 0.69201 6.1437 1.31812 6.73407L3.96872 9.23338L3.30352 12.8017C3.14558 13.6489 4.0425 14.277 4.7835 13.8775L7.99998 12.1435L11.2165 13.8775C11.9575 14.277 12.8544 13.6489 12.6965 12.8017L12.0312 9.23338L14.6819 6.73407C15.308 6.1437 14.9578 5.10463 14.1169 4.99452L10.4898 4.5196L8.91502 1.24156Z"
                                                    fill="#F6B60E"/></svg>
                                                <span className={'value-inner'}>
                                                    ({result?.themeInfo?.theme_store_meta?.[item.key]})
                                                </span>
                                            </span>
                                            :
                                            <span className="value">
                                                {`${item.key === 'price' && result?.themeInfo?.theme_store_meta?.[item.key] ? '$' : ''}${result?.themeInfo?.theme_store_meta?.[item.key] ? result?.themeInfo?.theme_store_meta?.[item.key] : item?.key === 'price' ? 'Free' : '-'}`}
                                            </span>
                                    }
                                </div>
                            ))
                        }
                    </div>
                    {
                        result?.themeInfo?.theme_store_meta?.source_url ?
                            <ButtonComponent className="btn"
                                             onClick={() => window.open(result?.themeInfo?.theme_store_meta?.source_url, '_blank')}
                            >
                                View theme <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 2.5C10.2209 2.5 10.4326 2.58796 10.5889 2.74414C10.7451 2.90034 10.8329 3.11211 10.833 3.33301C10.833 3.55402 10.7451 3.76657 10.5889 3.92285C10.4326 4.07893 10.2209 4.16699 10 4.16699H5C4.77899 4.16699 4.56741 4.25485 4.41113 4.41113C4.25485 4.56741 4.16699 4.77899 4.16699 5V15C4.16699 15.221 4.25485 15.4326 4.41113 15.5889C4.56741 15.7451 4.77899 15.833 5 15.833H15C15.221 15.833 15.4326 15.7451 15.5889 15.5889C15.7451 15.4326 15.833 15.221 15.833 15V10C15.833 9.77914 15.9211 9.56738 16.0771 9.41113C16.2334 9.25485 16.446 9.16699 16.667 9.16699C16.8879 9.16708 17.0997 9.25493 17.2559 9.41113C17.412 9.5674 17.5 9.77906 17.5 10V15C17.5 15.663 17.2364 16.2987 16.7676 16.7676C16.2987 17.2364 15.663 17.5 15 17.5H5C4.33696 17.5 3.70126 17.2364 3.23242 16.7676C2.76358 16.2987 2.5 15.663 2.5 15V5C2.5 4.33696 2.76358 3.70126 3.23242 3.23242C3.70126 2.76358 4.33696 2.5 5 2.5H10ZM16.667 2.5C16.8879 2.5001 17.0997 2.58795 17.2559 2.74414C17.412 2.90034 17.4999 3.11212 17.5 3.33301V6.66699C17.4999 6.88788 17.412 7.09966 17.2559 7.25586C17.0997 7.41205 16.8879 7.4999 16.667 7.5C16.446 7.5 16.2334 7.41214 16.0771 7.25586C15.921 7.09967 15.8331 6.88782 15.833 6.66699V5.34961L10.5918 10.583C10.5143 10.6611 10.4219 10.7233 10.3203 10.7656C10.2188 10.8079 10.11 10.8301 10 10.8301C9.89004 10.8301 9.7812 10.8079 9.67969 10.7656C9.57814 10.7233 9.48567 10.6611 9.4082 10.583C9.33024 10.5056 9.26785 10.4139 9.22559 10.3125C9.18328 10.211 9.16211 10.1012 9.16211 9.99121C9.16217 9.88136 9.18334 9.77231 9.22559 9.6709C9.26785 9.56951 9.33024 9.47778 9.4082 9.40039L14.6504 4.16699H13.333C13.1122 4.16692 12.9003 4.07895 12.7441 3.92285C12.5879 3.76657 12.5 3.55402 12.5 3.33301C12.5001 3.11211 12.5879 2.90034 12.7441 2.74414C12.9004 2.58794 13.1121 2.50007 13.333 2.5H16.667Z" fill="white"/></svg>
                            </ButtonComponent>
                            :
                            <span className="absence_note">
                                Theme not listed in Shopify Theme Store.
                            </span>
                    }
                </div>
            </div>
        </div>
    );
};

export default Index;